module.exports = __webpack_public_path__ + "img/1485683568.2c0e48ca.jpg";